import { PROMPT_NAMES } from 'woop-shared/prompts/names';
import { formatAdditionalDriverUsage, formatCoverageType } from '../utils/prompt-formatting';

export const PROMPT_FORMATTING = {
  [PROMPT_NAMES.COVERAGE_TYPE]: formatCoverageType,
  [PROMPT_NAMES.ADDITIONAL_DRIVER_USAGE]: formatAdditionalDriverUsage
};
